const doc = [({"no":({"js":({"components":({"admin":({"layout":({"menu":({"menu_content":({})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;